import "./locationBillingDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import LocationBillingDetailsViewComponent from "./location-billing-details-view/locationBillingDetailsViewComponent";
import LocationBillingDetailsEditComponent from "./location-billing-details-edit/locationBillingDetailsEditComponent";

interface LocationBillingDetailsViewEditComponentProps {
    locationDetails: any
    onUpdateBillingDetails: Function;
    onModeChange:Function;
    canEdit: boolean;
}

const LocationBillingDetailsViewEditComponent = (props: LocationBillingDetailsViewEditComponentProps) => {
    const {locationDetails, onUpdateBillingDetails,onModeChange,canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [locationBillingDetails, setLocationBillingDetails] = useState<any>(undefined);

    const handleBillingDetailsUpdate = useCallback((updatedBillingDetails: any) => {
        onUpdateBillingDetails(updatedBillingDetails);
        setMode("view");
    }, [onUpdateBillingDetails]);

    const handleBillingDetailsEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (locationDetails) {
            setLocationBillingDetails(locationDetails.billingDetails);
        }
    }, [locationDetails]);

    useEffect(()=>{
        onModeChange(mode)
    },[mode,onModeChange])

    return (
        <div className={'billing-details-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <LocationBillingDetailsViewComponent
                    locationBillingDetails={locationBillingDetails}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" &&
                <LocationBillingDetailsEditComponent
                                                     locationDetails={locationDetails}
                                                     locationId={locationDetails.id}
                                                     onUpdateComplete={handleBillingDetailsUpdate}
                                                     onEditCancel={handleBillingDetailsEditCancel}
                />
            }
        </div>
    );

};

export default LocationBillingDetailsViewEditComponent;
